import { createStore, applyMiddleware } from 'redux';
import {persistStore, persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import hardSet from 'redux-persist/lib/stateReconciler/hardSet';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';
import reduxThunk from 'redux-thunk';
import rootReducers from './reducers';
import {AUTH_USER} from './actions/types';

// import crosstabSync from 'redux-persist-crosstab';

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
const persistConfig = {
  key: 'root',
  storage,
  stateReconciler: hardSet
};
const persistedReducer = persistReducer(persistConfig, rootReducers);
export const store = createStoreWithMiddleware(persistedReducer);
export const persistor = persistStore(store);
// crosstabSync(persistor);


const token = localStorage.getItem('token');
// If We have a token, consider the User to be Signed In
if (token) {
	// we need to update application state
	store.dispatch({
		type: AUTH_USER,
		payload: token
	});
}
// Hot Module Replacement API
if (module.hot) {
  module.hot.accept(() => {
    const nextRootReducer = require('./reducers').default;
    store.replaceReducer(
      persistReducer(persistConfig, nextRootReducer)
    );
  });
}